export default "__VITE_ASSET__CJ9QnJ7z__"